module.exports = __webpack_public_path__ + "img/ic_rewards.262c7694.png";